import PhoneInput from "react-phone-number-input/input";

type FloatingPhoneProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string | undefined) => void;
  error?: string;
};

export function FloatingPhone({ id, label, value, onChange, error }: FloatingPhoneProps) {
  const errorId = `${id}-error`;

  return (
    <div>
      <div className="relative">
        <PhoneInput
          id={id}
          country="AZ"
          international
          withCountryCallingCode
          value={value}
          onChange={onChange}
          placeholder=" "
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
          className="home-float-input"
        />
        <label htmlFor={id} className="home-float-label home-float-label-pinned">
          {label} *
        </label>
      </div>
      {error ? (
        <p id={errorId} className="mt-1.5 text-[14px] leading-snug text-home-error">
          {error}
        </p>
      ) : null}
    </div>
  );
}
